import moment from 'moment';

import { BE_DATETIME_FORMAT } from 'src/constants';
import type { EligibleChangeDistance } from 'src/modules/profile/types';

import { t } from 'utils';

import { CHANGE_DISTANCE_ERROR_KEYS } from '../constants';

export type EligibleDistanceStatus = 'closed' | 'soldOut' | null;

const isRegistrationClosed = (distance: EligibleChangeDistance): boolean => {
  const now = moment();
  const from = moment.utc(distance.registrationStartsAt || NaN, BE_DATETIME_FORMAT).startOf('day');
  const to = moment.utc(distance.registrationEndsAt || NaN, BE_DATETIME_FORMAT).endOf('day');

  return (from.isValid() && from.isAfter(now)) || (to.isValid() && to.isBefore(now));
};

const isSoldOut = (distance: EligibleChangeDistance): boolean => distance.raceQty !== null && distance.racersCount >= distance.raceQty;

export const eligibleDistanceStatus = (distance: EligibleChangeDistance): EligibleDistanceStatus => {
  if (isRegistrationClosed(distance)) {
    return 'closed';
  }

  if (isSoldOut(distance)) {
    return 'soldOut';
  }

  return null;
};

export const changeDistanceErrorMessage = (code: string | null, message: string | null): string => {
  const key = code ? CHANGE_DISTANCE_ERROR_KEYS[code] : undefined;

  if (key) {
    return t.staticAsString(key);
  }

  return message || t.staticAsString('changeDistance.form.error');
};
